if (!customElements.get('before-after-slider')) {
  customElements.define(
    'before-after-slider',
    class BeforeAfterSlider extends HTMLElement {
      constructor() {
        super();
        this.frame = this.querySelector('.before-after__frame');
        this.handle = this.querySelector('.before-after__handle');
        this.dragging = false;

        this.onPointerDown = this.onPointerDown.bind(this);
        this.onPointerMove = this.onPointerMove.bind(this);
        this.onPointerUp = this.onPointerUp.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);

        if (this.handle) {
          this.handle.addEventListener('pointerdown', this.onPointerDown);
          this.handle.addEventListener('keydown', this.onKeyDown);
        }
        if (this.frame) {
          this.frame.addEventListener('pointerdown', this.onPointerDown);
        }
      }

      setPosition(percent) {
        const clamped = Math.min(100, Math.max(0, percent));
        this.style.setProperty('--before-after-position', `${clamped}%`);
        this.handle?.setAttribute('aria-valuenow', Math.round(clamped));
      }

      positionFromEvent(event) {
        const rect = this.frame.getBoundingClientRect();
        const x = event.clientX - rect.left;
        return (x / rect.width) * 100;
      }

      onPointerDown(event) {
        this.dragging = true;
        this.setPointerCapture?.(event.pointerId);
        window.addEventListener('pointermove', this.onPointerMove);
        window.addEventListener('pointerup', this.onPointerUp);
        this.setPosition(this.positionFromEvent(event));
        event.preventDefault();
      }

      onPointerMove(event) {
        if (!this.dragging) return;
        this.setPosition(this.positionFromEvent(event));
      }

      onPointerUp() {
        this.dragging = false;
        window.removeEventListener('pointermove', this.onPointerMove);
        window.removeEventListener('pointerup', this.onPointerUp);
      }

      onKeyDown(event) {
        const current = parseFloat(this.style.getPropertyValue('--before-after-position')) || 50;
        if (event.key === 'ArrowLeft') {
          this.setPosition(current - 5);
          event.preventDefault();
        } else if (event.key === 'ArrowRight') {
          this.setPosition(current + 5);
          event.preventDefault();
        }
      }
    }
  );
}
